<!-- 部门操作 -->
<template>
    <div class="store-modal-content">
        <div class="data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
                <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="formDataList" @tabs="
            (val) => {
              showTabs = val
            }
          ">
                    <template slot="tabs" slot-scope="scope">
                        <div class="table_content_box">
                            <!-- 主信息 -->
                            <div v-if="scope.index == 0">
                                <el-form size="mini" inline :model="sendDataInfo" label-width="150px" ref="sendDataInfo" :show-message="false">
                                    <el-form-item label="卡类型" prop="capId" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                        <label slot="label" :style="$common.labelStyle('卡类型')" v-html="$common.htmlLabel('卡类型')"></label>
                                        <el-input clearable v-model="sendDataInfo.capName" class="form_codition" @keyup.enter.native="openSearch('8820873997127708',0,'capName','capId,capName')">
                                            <el-button @click="openSearch('8820873997127708',0,'capName','capId,capName')" slot="append" icon="el-icon-search"></el-button></el-input>
                                    </el-form-item>
                                    <el-form-item label="会员卡号" prop="cardCode">
                                        <label slot="label" :style="$common.labelStyle('会员卡号')" v-html="$common.htmlLabel('会员卡号')"></label>
                                        <el-input ref="cardCodeInput" class="form_codition" v-model.trim="sendDataInfo.cardCode" :maxlength="$store.state.inputLength" placeholder="填写会员卡号"></el-input>
                                    </el-form-item>
                                    <el-form-item label="会员名字" prop="memName" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                        <label slot="label" :style="$common.labelStyle('会员名字')" v-html="$common.htmlLabel('会员名字')"></label>
                                        <el-input class="form_codition" v-model.trim="sendDataInfo.memName" :maxlength="$store.state.inputLength" placeholder="填写会员名字"></el-input>
                                    </el-form-item>
                                    <el-form-item label="助记码" prop="mne">
                                        <label slot="label" :style="$common.labelStyle('助记码')" v-html="$common.htmlLabel('助记码')"></label>
                                        <el-input class="form_codition" :disabled="true" v-model.trim="sendDataInfo.mne" :maxlength="$store.state.inputLength" placeholder="填写助记码"></el-input>
                                    </el-form-item>
                                    <el-form-item label="手机号" prop="memPhone" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                        <label slot="label" :style="$common.labelStyle('手机号')" v-html="$common.htmlLabel('手机号')"></label>
                                        <el-input class="form_codition" v-model.trim="sendDataInfo.memPhone" :maxlength="$store.state.inputLength" placeholder="填写手机号" type="number"></el-input>
                                    </el-form-item>
                                    <el-form-item label="性别" prop="memSex" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                        <label slot="label" :style="$common.labelStyle('性别')" v-html="$common.htmlLabel('性别')"></label>
                                        <el-select v-model="sendDataInfo.memSex" placeholder="请选择" class="form_codition" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                            <el-option label="男" :value="'男'"></el-option>
                                            <el-option label="女" :value="'女'"></el-option>
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item label="状态" prop="memState">
                                        <label slot="label" :style="$common.labelStyle('状态')" v-html="$common.htmlLabel('状态')"></label>
                                        <el-select v-model="sendDataInfo.memState" placeholder="请选择" class="form_codition">
                                            <el-option label="启用" :value="1"></el-option>
                                            <el-option label="禁用" :value="0"></el-option>

                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="生日" prop="memBirth">
                                        <label slot="label" :style="$common.labelStyle('生日')" v-html="$common.htmlLabel('生日')"></label>
                                        <el-date-picker v-model="sendDataInfo.memBirth" type="date" placeholder="选择生日" value-format="timestamp" class="form_codition">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="身份证" prop="memIdcard">
                                        <label slot="label" :style="$common.labelStyle('身份证')" v-html="$common.htmlLabel('身份证')"></label>
                                        <el-input class="form_codition" v-model.trim="sendDataInfo.memIdcard" :maxlength="$store.state.inputLength" placeholder="填写身份证"></el-input>
                                    </el-form-item>
                                    <el-form-item label="注册门店" prop="capId" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                        <label slot="label" :style="$common.labelStyle('注册门店')" v-html="$common.htmlLabel('注册门店')"></label>
                                        <el-input clearable v-model="sendDataInfo.storeName" class="form_codition" :disabled="dataActionBox.actionType === 1"
                                                  @keyup.enter.native="openSearch('293839281728',0,'storeName','storeId,storeName')">
                                            <el-button @click="openSearch('293839281728',0,'storeName','storeId,storeName')" slot="append" icon="el-icon-search"
                                                       :disabled="dataActionBox.actionType === 1"></el-button></el-input>
                                    </el-form-item>
                                    <el-form-item label="储值密码" prop="storedPwd">
                                        <label slot="label" :style="$common.labelStyle('储值密码')" v-html="$common.htmlLabel('储值密码')"></label>
                                        <el-input class="form_codition" v-model.trim="sendDataInfo.storedPwd" :maxlength="$store.state.inputLength" placeholder="填写储值密码" type="password"></el-input>
                                    </el-form-item>

                                    <div>
                                        <el-form-item label="备注" prop="remark">
                                            <label slot="label" :style="$common.labelStyle('备注')" v-html="$common.htmlLabel('备注')"></label>
                                            <el-input type="textarea" style="min-width: 600px !important" v-model.trim="sendDataInfo.remark" :maxlength="$store.state.inputLength" placeholder="填写备注"></el-input>
                                        </el-form-item>
                                    </div>
                                    <div>
                                        <el-form-item label="住址" prop="memAddress">
                                            <label slot="label" :style="$common.labelStyle('住址')" v-html="$common.htmlLabel('住址')"></label>
                                            <el-input type="textarea" style="min-width: 600px !important" v-model.trim="sendDataInfo.memAddress" :maxlength="$store.state.inputLength" placeholder="填写住址"></el-input>
                                        </el-form-item>
                                    </div>
                                </el-form>
                            </div>
                        </div>
                    </template>
                </v-tabs>
            </el-card>
        </div>
        <div class="dialog-footer">
            <el-button @click="drawerCancel">取 消</el-button>
            <el-button type="primary" @click="sendDataAction()">保 存</el-button>
        </div>

        <!-- 检索方案 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body="true" :append-to-body="true" @close="closeChild">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue"
export default {
    props: ["actionData"],
    name: "memberModal",
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                capId: "",
                capName: "",
                memBirth: "",
                memIdcard: "",
                memName: "",
                memPhone: "",
                memSex: "",
                memState: 1,
                storeName: "",
                storeId: "",
                storedPwd: "",
                remark: "",
                memAddress: "",
                mne: "",
            },
            formDataList: [],
            showTabs: "",
            DialogVisible: false, //判断是否打开检索方案弹框
            seTitle: "", //检索方案的名称
            seType: "", //检索方案查询条件字段
            seWidth: "", //检索方案弹框的宽度
            seTitle: "", //检索方案的名称
            sField: "", //赋值字段
            parentSearchData: {}, //检索方案补充的查询列表的查询条件
        }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.memName"() {
            //获取助记码
            this.sendDataInfo.mne = this.$common.createPinyinCode(
                this.sendDataInfo.memName,
                this.sendDataInfo.mne
            );
        },
    },
    //方法集合
    methods: {
        async openBox() {
            if (this.actionData.cate == 0) {
                this.showTabs = "新增会员信息"
                this.formDataList = [
                    {
                        jciName: "新增会员信息",
                        jurconfigform: [],
                    },
                ]
            } else {
                this.dataActionBox.boxTitle = "编辑会员信息"
                this.dataActionBox.openMode = "ltr"
                // 回显数据
                console.log(this.actionData.oldData, "oldData")

                if (this.actionData.oldData) {
                    this.sendDataInfo = this.actionData.oldData
                }

                this.formDataList = [
                    {
                        jciName: "编辑会员信息",
                        jurconfigform: [],
                    },
                ]
                this.showTabs = "编辑会员信息"
            }

            this.dataActionBox.actionType = this.actionData.cate
        },

        async sendDataAction() {
            // 表单验证
            this.$refs.sendDataInfo.validate(async (valid) => {
                if (valid) {
                    let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))

                    try {
                        let responseData
                        // 如果是新增
                        if (this.dataActionBox.actionType == 0) {
                            responseData = await this.$http.addMembermast(sendData)
                        }
                        // 如果是编辑
                        else if (this.dataActionBox.actionType == 1) {
                            responseData = await this.$http.updMembermast(sendData)
                        }

                        if (responseData.status == 200) {
                            this.$message({
                                message:
                                    this.dataActionBox.actionType == 0 ? "新增成功" : "编辑成功",
                                type: "success",
                            })
                            this.$emit("drawerCancel", false)
                            this.$emit("toDetail", responseData.result)
                        } else {
                            this.$message({
                                message: responseData.message,
                                type: "error",
                            })
                        }
                    } catch (error) {
                        console.error("error", error)
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        })
                    }
                } else {
                    this.$message({
                        message: "请填写必填项",
                        type: "error",
                    })
                    return false
                }
            })
        },
        //检索方案获取的数据清除
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach((item) => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        //获取检索方案弹框宽度
        getSeWidth(e) {
            this.seWidth = e + "%"
        },
        //获取检索方案弹框名称
        getSearchName(e) {
            this.seTitle = e
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.seId = sId //检索方案Id
            this.sField = sField //赋值字段
            this.DialogVisible = true //判断是否打开弹框
            this.seType = type
        },

        //检索方案返回的数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false
                this.paramValue(val) //赋值字段，赋值
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",")
            arr.forEach((item) => {
                this.sendDataInfo[item] = val[item]
            })
        },
        //关闭提取、检索方案弹框关闭 创建键盘事件
        closeChild() {
            addEventListener("keyup", this.keyUp) //创建监听键盘事件
        },

        drawerCancel() {
            this.$confirm("确认关闭弹窗吗？未保存的数据将丢失。", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit("drawerCancel", false)
                })
                .catch(() => { })
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.openBox()
    },
}
</script>
<style scoped>
.store-modal-content {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
}

.data_action_form {
    width: 100%;
}

.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: auto;
    overflow-y: visible;
}

.btns {
    display: flex;
    position: absolute;
    z-index: 999;
    padding-left: 10px;
    padding-top: 2px;
}

::v-deep.xunjia tr {
    height: 39px !important;
}

#smManrange {
    width: 100%;
    display: flex;
    padding-left: 83px;
    margin-bottom: 10px;
}

::v-deep #smManrange .el-form-item__content {
    width: 100% !important;
}

::v-deep #smManrange .el-textarea__inner {
    width: 76% !important;
    margin-right: 20px;
    font-size: 12px;
}

.cmContent {
    padding-left: 10px;
    width: 90%;
}

.mem-day-type-content {
    text-align: center;
    padding: 20px 0;
}

.mem-day-type-content .el-radio {
    margin: 0 20px;
    font-size: 16px;
}

.mem-day-content {
    max-height: 400px;
    overflow-y: auto;
}

.mem-day-content p {
    margin-bottom: 15px;
    font-weight: bold;
    color: #333;
}

.mem-day-content .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.mem-day-content .el-checkbox {
    margin-right: 15px;
    margin-bottom: 10px;
    min-width: 80px;
}

.mem-day-type-section {
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #eee;
}

.mem-day-type-section h4 {
    margin-bottom: 10px;
    color: #333;
    font-size: 14px;
}

.mem-day-type-section .el-radio {
    margin-right: 20px;
    font-size: 14px;
}

.mem-day-detail-section h4 {
    margin-bottom: 15px;
    color: #333;
    font-size: 14px;
}

.dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background: #fff;
    height: 46px;
    padding: 5px 10px;
    margin-top: 20px;
    border-top: 1px solid #eee;
}
</style>
